export default __webpack_public_path__ + "static/media/Emerson.31656e72.png";